// extracted by mini-css-extract-plugin
export default {"root":"Unauthorized_root__npmzQ","label":"Unauthorized_label__gyEXS","description":"Unauthorized_description__TNepF","title":"Unauthorized_title__1bCCF"};